const buildCategoryTree = (flat, term_id) => {
    var _a, _b, _c;
    const root = [];
    console.log({ buildCategoryTree: term_id });
    for (let node of flat) {
        node.selected = node.term_id === term_id;
        if (node.parent === 0) {
            node.parent_node = null;
            root.push(node);
            continue;
        }
        const parentIndex = flat.findIndex((el) => el.term_id === node.parent);
        node.parent_node = flat[parentIndex];
        if (!((_a = flat[parentIndex]) === null || _a === void 0 ? void 0 : _a.children)) {
            flat[parentIndex].children = [node];
            continue;
        }
        else {
            (_c = (_b = flat[parentIndex]) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c.push(node);
            continue;
        }
    }
    const selected_node = flat.find((el) => el.selected);
    if (selected_node) {
        selectParentCategories(selected_node);
        selectChildren(selected_node);
    }
    return root;
};
const buildCategoryTree2 = (flat, term_ids) => {
    var _a, _b, _c;
    const root = [];
    console.log({ buildCategoryTree: term_ids });
    for (let node of flat) {
        node.selected = term_ids.includes(node.term_id);
        if (node.parent === 0) {
            node.parent_node = null;
            root.push(node);
            continue;
        }
        const parentIndex = flat.findIndex((el) => el.term_id === node.parent);
        node.parent_node = flat[parentIndex];
        if (!((_a = flat[parentIndex]) === null || _a === void 0 ? void 0 : _a.children)) {
            flat[parentIndex].children = [node];
            continue;
        }
        else {
            (_c = (_b = flat[parentIndex]) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c.push(node);
            continue;
        }
    }
    const selected_node = flat.find((el) => el.selected);
    if (selected_node) {
        selectParentCategories(selected_node);
        selectChildren(selected_node);
    }
    return root;
};
function selectParentCategories(category) {
    var _a, _b;
    if (category.parent_node !== null) {
        category.parent_node.selected = (_b = (_a = category.parent_node) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.some((el) => el.selected);
        selectParentCategories(category.parent_node);
    }
}
const findCategory = (tree, id) => {
    for (let ctg in tree) {
        let category = tree[ctg];
        if (category.id === id) {
            return category;
        }
        else if (category === null || category === void 0 ? void 0 : category.children) {
            return findCategory(category === null || category === void 0 ? void 0 : category.children, id);
        }
    }
    return null;
};
const selectChildren = (selectedCtg) => {
    var _a;
    (_a = selectedCtg === null || selectedCtg === void 0 ? void 0 : selectedCtg.children) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
        child.selected = selectedCtg.selected;
        if (child === null || child === void 0 ? void 0 : child.children)
            selectChildren(child);
    });
};
const flattenSelected = (tree) => {
    var _a;
    let selected = [];
    for (let i in tree) {
        let ctg = tree[i];
        if (ctg.selected && !((_a = ctg === null || ctg === void 0 ? void 0 : ctg.children) === null || _a === void 0 ? void 0 : _a.some((el) => el.selected)))
            selected.push(ctg.term_id);
        if (ctg === null || ctg === void 0 ? void 0 : ctg.children)
            selected = selected.concat(flattenSelected(ctg === null || ctg === void 0 ? void 0 : ctg.children));
    }
    return selected;
};
export { buildCategoryTree, buildCategoryTree2, selectChildren, flattenSelected, };
